import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParaFooterComponent } from './para-footer.component';

@NgModule({
	declarations: [ParaFooterComponent],
	imports: [CommonModule],
	exports: [ParaFooterComponent],
})
export class ParaFooterModule {}
